import React from 'react';
import classnames from 'classnames';
import { iconContainer } from './styles.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function IconContainer({ marginClass, className, children }) {
  if (!marginClass) marginClass = `${margin.left_xxs} ${margin.right_sm}`;
  return (
    <div className={classnames(iconContainer, marginClass, className)}>
      {children}
    </div>
  );
}
